import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import StickyNote2RoundedIcon from '@mui/icons-material/StickyNote2Rounded';
import { Avatar, Box, Typography } from '@mui/material';
import clsx from 'clsx';
import TimeAgo from 'javascript-time-ago';
import { useTranslation } from 'react-i18next';
import { NotificationFieldsFragment } from '../../../../../../../../generated/core-api/graphql-react-query';

export default function NewContentNotificationBox(props: { notification: NotificationFieldsFragment }) {
  const { notification } = props;
  const { t, i18n } = useTranslation('widgets');
  const timeAgo = new TimeAgo(i18n.language);

  return (
    <>
      <Avatar className="user">
        <StickyNote2RoundedIcon />
      </Avatar>
      <Box className="message newContent">
        <Typography variant="subtitle1">
          <strong>{notification.event.author?.displayName}</strong>
          {t('notifications.card.created')}
        </Typography>
        <Typography variant="body1" component="div">
          <div className={clsx('project', { deleted: notification.event.project?.archived })}>{notification.event.project?.name}</div>
          <ChevronRightIcon />
          <div className={clsx('project', { deleted: notification.event.card?.deletedAt })}>{notification.event.card?.title}</div>
        </Typography>
        <Typography variant="subtitle2">
          {timeAgo.format(new Date(notification.date))}
        </Typography>
        <Typography variant="subtitle2">
          {notification.event.card?.deletedAt && `${t('notifications.deleted')} ${timeAgo.format(new Date(notification.event.card?.deletedAt))}`}
        </Typography>
      </Box>
    </>
  );
}
